import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { services, waymining } from '../../data/services';
import '../../styles/Company.css';

interface CompanyNavigationProps {
  scrolled?: boolean;
}

const CompanyNavigation: React.FC<CompanyNavigationProps> = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Navigate to a section on the company home (works from any route).
  const goToSection = (sectionId: string) => {
    setMobileMenuOpen(false);
    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  const closeAll = () => {
    setMobileMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className={`company-nav ${scrolled ? 'scrolled' : ''}`}>
      <div className="company-nav-container">
        <Link to="/" className="company-brand" onClick={closeAll}>
          <span className="company-brand-mark">WM</span>
          <span className="company-brand-text">Waymining</span>
        </Link>

        <div className={`company-nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <button onClick={() => goToSection('home')}>Home</button>

          <div
            className={`company-dropdown ${dropdownOpen ? 'open' : ''}`}
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <button
              className="company-dropdown-toggle"
              onClick={() => setDropdownOpen((o) => !o)}
            >
              Products &amp; Services <ChevronDown size={16} />
            </button>

            <div className="company-dropdown-menu">
              <span className="company-dropdown-heading">Products</span>
              <Link to={waymining.path} onClick={closeAll}>
                {waymining.name}
                <small>{waymining.tagline}</small>
              </Link>

              <span className="company-dropdown-heading">Services</span>
              {services.map((s) => (
                <Link key={s.slug} to={`/services/${s.slug}`} onClick={closeAll}>
                  {s.name}
                  <small>{s.tagline}</small>
                </Link>
              ))}
            </div>
          </div>

          <button onClick={() => goToSection('about')}>About</button>
          <button onClick={() => goToSection('contact')}>Contact</button>
          <button className="company-cta" onClick={() => goToSection('contact')}>
            Get in Touch
          </button>
        </div>

        <button
          className="company-menu-toggle"
          onClick={() => setMobileMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default CompanyNavigation;
